export default "__VITE_ASSET__Co2S8WMr__"